var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',{staticClass:"cascader"},[_c('mars-view',{staticClass:"hidden-update"},[_vm._v("\n    "+_vm._s(_vm.count)+"\n")]),_vm._l((_vm.list),function(columnItem,columnIndex){return _c('mars-view',{key:columnIndex,ref:"column",refInFor:true,staticClass:"column",class:[
        _vm.column === 2
            ? 'column' + columnIndex
            : ''
    ],style:({
        height: _vm.height,
        maxHeight: _vm.maxHeight,
        '-webkit-box-flex': _vm.columnWidthRatio[columnIndex],
        '-webkit-flex': _vm.columnWidthRatio[columnIndex],
        flex: _vm.columnWidthRatio[columnIndex]
    }),nativeOn:{"touchstart":function($event){return _vm.handleColumnTouchStart($event, {
        columnIndex
    })},"touchmove":function($event){return _vm.handleColumnTouchMove($event, {
        columnIndex
    })}}},[(columnItem && columnItem.options)?_vm._l((columnItem.options),function(option,optionIndex){return _c('mars-view',{key:optionIndex,staticClass:"option c-line-clamp1 c-font-normal",class:{
                'option-selected': columnItem.selectedIndex === optionIndex
            },style:({
                color: columnItem.selectedIndex === optionIndex
                    ? _vm.primaryColor
                        ? _vm.primaryColor
                        : '#5183FF'
                    : '#333'
            }),nativeOn:{"click":function($event){return _vm.handleOptionTap({
                column: _vm.column,
                columnIndex,
                option,
                optionIndex,
                options: columnItem.options
            })}}},[_vm._v("\n            "+_vm._s(option.text)+"\n            "),(option.extend)?_c('mars-view',{staticClass:"c-font-small c-line-clamp1 c-color-gray"},[_vm._v("\n                "+_vm._s(option.extend)+"\n            ")]):_vm._e()],1)}):_vm._e()],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }